import { resetAllPasswordStates, resetAllStates, resetMfaSetup } from "../authSlice";
import { resetProviderDetails } from "../providerDetailsSlice";
import { resetFormOptions } from "../formOptionsSlice";
import { clearDataFromStorage } from "./logOutThunk";
import type { AuthAppDispatch } from "../store";

export const resetAllAppStates = () => (dispatch: AuthAppDispatch) => {
  dispatch(resetAllStates());
  dispatch(resetProviderDetails());
  dispatch(resetFormOptions());
  dispatch(resetMfaSetup());
  clearDataFromStorage();
};

export const resetAllPasswordRelatedStates =
  () => async (dispatch: AuthAppDispatch) => {
    dispatch(resetAllPasswordStates());
  };
